import { useState, useEffect } from "react";
import { useI18n } from "../lib/i18n.jsx";

export default function OAuthCallback() {
  const { t } = useI18n();
  const [state, setState] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");
    const spaceId = params.get("state") || localStorage.getItem("oauth-pending-spaceId") || "";

    if (error) {
      localStorage.setItem("github-oauth-code", JSON.stringify({ error, timestamp: Date.now() }));
      setState("error");
      setMessage(error);
      return;
    }

    if (!code) {
      setState("error");
      setMessage("No authorization code received");
      return;
    }

    // Store code in localStorage for the opener window to pick up
    localStorage.setItem("github-oauth-code", JSON.stringify({
      code,
      spaceId,
      timestamp: Date.now(),
    }));

    setState("success");
    setMessage("GitHub connected! You can close this window.");

    setTimeout(() => {
      try { window.close(); } catch {}
    }, 500);
  }, []);

  return (
    <div className="oauth-callback-page">
      <div className="oauth-card">
        {state === "loading" && (
          <>
            <div className="spinner" />
            <h2>{t("oauth_callback_title")}</h2>
            <p>{t("oauth_callback_desc")}</p>
          </>
        )}
        {state === "success" && (
          <>
            <div className="check-icon big">✓</div>
            <h2>{t("oauth_success_title")}</h2>
            <p>{t("oauth_success_desc")}</p>
          </>
        )}
        {state === "error" && (
          <>
            <div className="error-icon big">✕</div>
            <h2>{t("oauth_error_title")}</h2>
            <p>{message}</p>
            <button className="btn btn-primary" onClick={() => window.close()}>
              {t("cancel")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
